import axiosInstance from "../lib/axios.instance";
import { IReferUserRequest, IReferUserResponse } from "../types/user.types";

export const referUser = async (data: IReferUserRequest): Promise<IReferUserResponse> => {
    const response = await axiosInstance.post<IReferUserResponse>("users/refer_user/", data);
    return response.data;
};
